<template>
<div class="page-customerService-ui">
    <div class="cs-btn" @click="clickCs">
        <img :src="datas.icon" class="kf-img" v-if="datas.icon">
        <i class="iconfont icona-kefu4" v-else></i>
        <p>联系客服</p>
    </div>
    <serviceQcode ref="serviceQcode" :qrCodeUrl="datas.qrCode"></serviceQcode>
</div>
</template>

<script>
// 标题
import {
    jAlert3
} from '@/base/jAlert/jAlert';
import serviceQcode from "@/components/serviceQcode";
import { miniProgram } from "@/utils/miniProgram";
export default {
    name: "customerService",
    data() {
        return {
            showQrcode: false
        };
    },
    props: ["datas"],
    methods: {
        async clickCs() {
            console.log(this.datas)
            if (this.datas.csType == 1) {
                if (this.datas.phone) {
                    window.location.href = "tel:" + this.datas.phone
                }

            } else if (this.datas.csType == 2) {
                if (this.datas.url) {
                    var isMiniProgram = await miniProgram.isMiniProgram();
                    if(this.datas.url.indexOf("/pages")==0&&isMiniProgram){
                      
                        miniProgram.navigateTo({
                            url:this.datas.url
                        });

                    }else{
                        window.location.href = this.datas.url
                    }
                }

            } else if (this.datas.csType == 3) {
                this.$refs.serviceQcode.isServiceQcode = true
            } else if (this.datas.csType == 4) {
                if (this.datas.content) {
                    jAlert3(this.datas.content)
                }
            }
        }
    },
    components: {
        serviceQcode
    },

};
</script>

<style lang="less">
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.page-customerService-ui {
    z-index: 999;

    .cs-btn {
        position: fixed;
        bottom: 4.866667rem;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 999;
        background: #fff;
        border-radius: 100px 0px 0px 100px;
         box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
        padding:0.133333rem 0.266667rem 0.213333rem 0.4rem;
        .kf-img{
            width: 0.88rem;
            height: auto;
            margin-bottom:0.213333rem;
        }
        i {
            font-size: 34px;
            color: @color-theme;
        }

        p {
            margin-top: -2px;
            font-size: 10px;
            color: @color-theme;
        }
    }

    .attention-box {
        position: fixed;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        top: 0;
        left: 0;
        z-index: 999;

        .attention-container {
            position: absolute;
            left: 50%;
            top: 50%;
            background: url("https://xcx.ihotel.cn/mall/qrCode-bg3.png") no-repeat;
            background-size: contain;
            text-align: center;
            transform: translate(-50%, -55%);
            width: 8.67rem;
            height: 10.453333rem;
            box-sizing: border-box;

            img.qrcode {
                margin-top: 0.666667rem;
                width: 5.333333rem;
                height: 5.333333rem;
                // box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
            }

            .close {
                position: absolute;
                top: 0;
                right: 0;
                padding: 0.266667rem;
                font-size: 12px;

                i {
                    font-size: 12px;
                }
            }

            .public-code-desc {
                margin-top: 0.533333rem;
                font-size: 16px;
                color: #333333;
            }

            .txt {
                line-height: 1.44rem;
                font-size: 14px;
                color: #666666;
                text-align: center;
                width: 100%;
            }

        }

    }

}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/customerService.vue